const urls = {
  notFound: '/not-found',

  // Authenticaction
  signIn: '/signin',
  signUp: '/create-account',
  confirmPhoneNumber: '/signup/confirm-phone-number',
  confirmationCode: '/signup/confirmation-code',
  location: '/signup/location',
  requestAccess: '/signup/request-access',

  // Payments
  payments: '/payments',
  paymentRecords: '/payments/records',
  disputes: '/payments/disputes',
  disputeDetails: '/payments/disputes/:id',
  paymentSettings: '/payments/settings',
  newPaymentMethod: '/payments/new-method',
  paymentMethodStatus: '/payments/new-method/status',
  experientialRewardsDetails: '/payments/experiential-reward-details',

  // Account
  account: '/account',
  profile: '/account/profile',
  personalProfile: '/account/profile/:url',
  urlProfile: '/p/:url',
  network: '/account/network',
  settings: '/account/settings',
  integrations: '/account/integrations',
  slackIntegration: '/account/integrations/slack',
  linkedinIntegration: '/account/integrations/linkedin',
  linkedinProfileImport: '/account/profile/linkedin-import',
  publicProfile: '/account/public-profile',
  syncSources: '/account/network/sync-sources',
  networkCsvImport: '/account/network/csv-import',
  csvImportHistory: '/account/network/csv-import-history',
  linkedinImportHistory: '/account/network/linkedin-import-history',
  linkedinZipFileImport: '/account/network/linkedin-import',
  contactRecommendations: '/account/network/contact/:contactId/recommendations',

  // Browse
  browse: '/jobs',
  browseAll: '/jobs/all',
  openingDetails: '/jobs/details',
  jobDetail: '/job/:jobId',

  // Strengthen Questions
  candidateStrengthenQuestions: '/strengthen-questions/candidate',
  referralStrengthenQuestions: '/strengthen-questions/referral',

  // Misc
  slackRedirect: '/slack/redirect',
  verifyAdditonalEmail: '/verify-additional-email',
  unsubscribe: '/unsubscribe',

  // Company profile
  companyProfile: '/company/:companyName',

  // Dashboard
  dashboard: '/dashboard',
  recommendedJobs: '/recommended-jobs',

  // Tracker
  tracker: '/tracker',

  // Referral Flow
  refer: '/refer',
  referralFlowStrengthen: '/refer/:referralId/strengthen',
  referralFlowSuccess: '/refer/:referralId/success',
  // Company referral
  companyReferral: '/company/:companyName/refer',
  companyReferralStrengthen: '/company/:companyName/refer/:referralId/strengthen',
  companyReferralSuccess: '/company/:companyName/refer/:referralId/success',

  // Application Flow
  applicationFlow: '/apply',
  applicationFlowStrengthen: '/apply/:applicationId/strengthen',
  applicationFlowSuccess: '/apply/:applicationId/success',
  // Company Application Flow
  companyApplicationFlow: '/company/:companyName/apply',
  companyApplicationFlowStrengthen: '/company/:companyName/apply/:applicationId/strengthen',
  companyApplicationFlowSuccess: '/company/:companyName/apply/:applicationId/success',

  // Organization General Signup
  organizationSignup: '/t/:organizationIdentifier/signup',
};

export default urls;
